import styles from './BlueTableHeading.module.scss'

const BlueTableHeading = ({ children, className }) => {
  return (
    <div className={`${styles['text-blue']} ${className}`}>
      {children}
    </div>
  );
};

export default BlueTableHeading;